/** Display label for delete-ticket confirmation (subject/title or ticket id). */
export function formatTicketDeleteLabel(parts: {
  title?: string;
  subject?: string;
  uiId?: string;
  id: string;
}): string {
  const text = (parts.title ?? parts.subject ?? "").trim();
  if (text) return text;
  return parts.uiId ?? parts.id;
}
